import {ChevronsUpDown,EllipsisVertical} from "lucide-react";
import React, {useState } from "react";
import { adjustDateTime, can_visit, convertSecondsToTime, exchangeDate } from "../../helpers";
import CCMSinglePatientViewModal from "../Modal/CCMSinglePatientViewModal";
import Skeleton from "react-loading-skeleton";

const styles = {
  display: "flex",
  alignItems: "center",
  gap: "5px",
  cursor: "pointer",
};

export default function CCMDataTable(props) {
  const {
    tableData = [],
    handleCheckboxChange = () => {},
    handleSelectAll = () => {},
    reloadData = () => {},
    reloadDataFilter = {},
    dataLoading,
    setDataLoading = () => {},
    globalCheckedIds,
  } = props;

  const [activeCCMPatientViewModal, setCCMActivePatientViewModal] = useState(false);
  const [CCMPatientData, setCCMPatientData] = useState({});
  const [orderBy, setOrderBy] = useState();
  const [previousScrollPosition, setPreviousScrollPosition] = useState(0);

  const handleOrderChange = (name, type = "asc") => {
    name = name.toString();
    setOrderBy(name);
    if (reloadDataFilter.order_by && reloadDataFilter.order_by[0] === name) {
      if (reloadDataFilter.order_by[1] === "asc") {
        type = "desc";
      }
    }
    const orderFilter = { order_by: [name, type.toString()] };
    const filter_merge = { ...reloadDataFilter, ...orderFilter };
    setDataLoading(true);
    reloadData(filter_merge);
  };

  const handlePatientViewModal = (data) => {
    setCCMPatientData(data);
    setCCMActivePatientViewModal(!activeCCMPatientViewModal);
    setPreviousScrollPosition(window.scrollY);
    window.scrollTo(0, 0);
  }


  return (
    <>
      <div className="docpro_table_responsive docpro_toor_box7" style={{ minHeight: "300px" }}>
        <table className="docpro_mb_0" style={{ height: "100%" }}>
          <thead>
            <tr>
              <th style={{ width: "45px" }}>
                <div className="docpro_checkbox" style={{ top: "3px" }}>
                  <input
                    type="checkbox"
                    checked={tableData.length > 0 && tableData.every((row) => globalCheckedIds?.has(row?.id))}
                    onChange={handleSelectAll}
                    disabled={tableData.length === 0}
                  />
                  <label></label>
                </div>
              </th>
              {can_visit("_role_enterprise") && (
                <>
                  {/* <th 
                    onClick={() => {
                      handleOrderChange("account_name");
                    }}
                    className={orderBy === "account_name" ? "docpro_accent_color" : ""}
                  >
                    <div style={styles}>
                      Practice Name <ChevronsUpDown size={"12"} />
                    </div>
                  </th>
                  <th 
                    onClick={() => {
                      handleOrderChange("location_name");
                    }}
                    className={orderBy === "location_name" ? "docpro_accent_color" : ""}
                  >
                    <div style={styles}>
                      Location <ChevronsUpDown size={"12"} />
                    </div>
                  </th> */}
                  <th> Practice Name </th>
                  <th> Location </th>
                </>
              )}
              <th 
              onClick={() => {
                handleOrderChange("created_at");
              }}
              className={orderBy === "created_at" ? "docpro_accent_color" : ""}
              >
                <div style={styles}>
                  Created At <ChevronsUpDown size={"12"} />
                </div>
              </th>
              <th>
                <div style={styles}>
                  Last Name
                </div>
              </th>
              <th>
                <div>
                  <div style={styles}>
                    First Name
                  </div>
                </div>
              </th>
              <th>
                <div style={styles}>
                  Date of Birth
                </div>
              </th>
              <th>
                <div style={styles}>
                  Insurance Name
                </div>
              </th>
              <th>
                <div style={styles}>
                Recording Duration
                </div>
              </th>
              <th className="docpro_text_center">Action</th>
            </tr>
          </thead>
          <tbody>
            {!dataLoading ? (
              tableData.length > 0 ? (
                tableData?.map((item, index) => (
                  <tr key={index} className={`row_${item.id} pointer`}>
                    <td style={{ width: "45px" }}>
                      <div className="docpro_checkbox" style={{ top: "3px" }}>
                        <input
                          type="checkbox"
                          checked={globalCheckedIds.has(item.id)}
                          onChange={() => handleCheckboxChange(item.id, item)}
                        />
                        <label></label>
                      </div>
                    </td>
                    {can_visit("_role_enterprise") && (
                      <>
                        <td onClick={() => handlePatientViewModal(item)}>
                          {item.accountName}
                        </td>
                        <td onClick={() => handlePatientViewModal(item)}>
                          {item.locationName}
                        </td>
                      </>
                    )}

                    <td onClick={() => handlePatientViewModal(item)}>
                      {adjustDateTime(item.createdAt)}
                    </td>
                    <td className="bulk" onClick={() => handlePatientViewModal(item)}>
                      {item.lastName}
                    </td>
                    <td className="bulk" onClick={() => handlePatientViewModal(item)}>
                      {item.firstName}
                    </td>

                    <td onClick={() => handlePatientViewModal(item)}>
                      {exchangeDate(item.dob)}
                    </td>
                    <td onClick={() => handlePatientViewModal(item)}>
                      {item.insuranceName}
                    </td>
                    <td className="bulk" onClick={() => handlePatientViewModal(item)}>
                      {item.recordingDuration ? `${convertSecondsToTime(item.recordingDuration)}` : ""}
                    </td>
                    {/* <td className="bulk hidden">
                      {item.id}
                    </td> */}

                    <td className="docpro_text_center">
                      <div className="docpro_icon_btns" phone={item.mobilePhone}>
                        <div className="dropdown-container relative">
                          <button className="docpro_icon_btn">
                            <EllipsisVertical width={18} height={18} />
                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="no_data docpro_p_0" style={{ height: "300px" }} colSpan={`${can_visit("_role_enterprise") ? 10 : 8}`}>
                    No data available
                  </td>
                </tr>
              )
            ) : (
              Array.from({ length: 8 }).map((_, index) => (
                <tr key={index} style={{ height: '50px' }}>
                  <td style={{ width: "45px" }}> <Skeleton width="1.2rem" borderRadius="8px"></Skeleton> </td>
                  {can_visit("_role_enterprise") && (
                    <>
                      <td> <Skeleton width={`${3 + (index % 2)}rem`} borderRadius="8px"></Skeleton> </td>
                      <td> <Skeleton width={`${4 + (index % 1.2)}rem`} borderRadius="8px"></Skeleton> </td>
                    </>
                  )}
                  <td> <Skeleton width={`${6 + (index % 2)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${5 + (index % 2.5)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${4 + (index % 2.8)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width="4rem" borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${5 + (index % 3.5)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${3 + (index % 1.5)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td className="text-center"> <Skeleton width="3rem" borderRadius="8px"></Skeleton> </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      
      {activeCCMPatientViewModal && (
        <CCMSinglePatientViewModal
          ccm_patient_data={CCMPatientData}
          activeModal={activeCCMPatientViewModal}
          setActiveModal={setCCMActivePatientViewModal}
          previousScrollPosition={previousScrollPosition}
        />
      )}
    </>
  );
}
